import { createAction } from '@reduxjs/toolkit';

export const updateUserPreferences = createAction<{
  email: string;
  emailConsent: boolean;
}>('user/USER_PREFERENCES_UPDATE');
